import update from 'immutability-helper'

export const ALPHABETICAL_ASC = 'ALPHABETICAL_ASC'
export const ALPHABETICAL_DESC = 'ALPHABETICAL_DESC'
export const RECENTLY_ADDED = 'RECENTLY_ADDED'
export const OLDEST_FIRST = 'OLDEST_FIRST'

const SET_COLLECTIONS_SORTING = Symbol('SET_COLLECTIONS_SORTING')

const getInitialState = () => {
  const sortingPreference = window.localStorage.getItem('collectionsSorting')

  return {
    sorting: sortingPreference || ALPHABETICAL_ASC,
  }
}

const initialState = getInitialState()

export default (state = initialState, action) => {
  switch (action?.type) {
    case SET_COLLECTIONS_SORTING: {
      const { sorting } = action.payload

      window.localStorage.setItem('collectionsSorting', sorting)

      return update(state, {
        $merge: { sorting },
      })
    }

    default:
      return state
  }
}

export const setCollectionsSorting = sorting => ({
  type: SET_COLLECTIONS_SORTING,
  payload: { sorting },
})

export const getCollectionsSorting = state => {
  return state.collections?.sorting || ALPHABETICAL_ASC
}

export const sortCollections = (collections, sorting, metrics = {}) => {
  if (!collections || !collections.length) return collections

  const sorted = [...collections]

  switch (sorting) {
    case ALPHABETICAL_ASC:
      return sorted.sort((a, b) => {
        if (a.name === 'Users') return -1
        if (b.name === 'Users') return 1

        return a.name.localeCompare(b.name)
      })

    case ALPHABETICAL_DESC:
      return sorted.sort((a, b) => {
        if (a.name === 'Users') return -1
        if (b.name === 'Users') return 1

        return b.name.localeCompare(a.name)
      })

    case RECENTLY_ADDED:
      return sorted.sort((a, b) => {
        if (a.name === 'Users') return -1
        if (b.name === 'Users') return 1

        const aMetric = metrics[a.tableId]
        const bMetric = metrics[b.tableId]

        if (aMetric?.createdAt && bMetric?.createdAt) {
          return new Date(bMetric.createdAt) - new Date(aMetric.createdAt)
        }

        return b.tableId.localeCompare(a.tableId)
      })

    case OLDEST_FIRST:
      return sorted.sort((a, b) => {
        if (a.name === 'Users') return -1
        if (b.name === 'Users') return 1

        const aMetric = metrics[a.tableId]
        const bMetric = metrics[b.tableId]

        if (aMetric?.createdAt && bMetric?.createdAt) {
          return new Date(aMetric.createdAt) - new Date(bMetric.createdAt)
        }

        return a.tableId.localeCompare(b.tableId)
      })

    default:
      return sorted
  }
}
